import React, { useEffect, useState } from "react";
import ProductVariantProvider from "../providers/product-variant-provider";
import SidebarAnimationProvider from "../providers/sidebar-animation-provider";
import WatchViewProvider from "../providers/watch-view-provider";
import Sidebar from "./sidebar-container";
import WatchPreviewContainer from "./watch-preview/watch-preview-container";

const Layout = () => {
  const [screenHeight, setScreenHeight] = useState(`${window.innerHeight}px`);

  useEffect(() => {
    window.addEventListener("resize", () =>
      setScreenHeight(`${window.innerHeight}px`)
    );
  }, []);

  return (
    <div
      className="relative bg-backgroud flex flex-col md:flex-row justify-between"
      style={{ minHeight: screenHeight }}
    >
      <ProductVariantProvider>
        <WatchViewProvider>
          <WatchPreviewContainer />
          <SidebarAnimationProvider>
            <Sidebar />
          </SidebarAnimationProvider>
        </WatchViewProvider>
      </ProductVariantProvider>
    </div>
  );
};

export default Layout;
